import { useCallback, useContext, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { FilterTypes } from '../../reducers/filter';
import { useIsFilterSet } from '../../selectors/filter';
import { getPassengerList } from '../../selectors/passengers';
import { getCurrentLegCrewType } from '../../selectors/screen';
import { SidebarContext } from '../PageLayout/ContextProvider';
import { useMobileWidth } from '../hooks/useMobileWidth';

export const useFilter = () => {
    const { handleToggleFilterSidebar } = useContext(SidebarContext);
    const isFilterSet = useIsFilterSet(FilterTypes['PASSENGERS']);

    const handleFilterClick = useCallback(
        (event) => {
            event.preventDefault();

            handleToggleFilterSidebar(true);
        },
        [handleToggleFilterSidebar]
    );

    return { isFilterSet, handleFilterClick };
};

export const usePassengerPage = () => {
    const [tableView, toggleTableView] = useState(true);
    const passengerList = useSelector(getPassengerList);
    const crewType = useSelector(getCurrentLegCrewType);

    const handleChangeView = () => toggleTableView((prevState) => !prevState);

    const { isMobilePortrait } = useMobileWidth();
    const { t: translate } = useTranslation();

    const toggle = useMemo(() => (
        {
            label: translate('labels.tableView'),
            defaultToggled: tableView,
            onToggle: handleChangeView,
        }
    ), [tableView, translate, handleChangeView]);

    return {
        crewType,
        isMobilePortrait,
        passengerList,
        tableView,
        toggle,
    };
};
